var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.auth)?_c('v-app',[_c('AuthUser')],1):_c('v-app',[_c('vue-confirm-dialog'),_c('NotAuthUser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }